const PLACEHOLDER_IMAGE_BASE = 'https://focuslee-production-images.s3.eu-west-1.amazonaws.com/focuslee-ui/placeholders';

export const PLACEHOLDER_IMAGE = {
    achievements: `${PLACEHOLDER_IMAGE_BASE}/achievements-empty.png?v=1`,
    activity: `${PLACEHOLDER_IMAGE_BASE}/activity-empty.png?v=1`,
    goals: `${PLACEHOLDER_IMAGE_BASE}/goals-empty.png?v=1`,
    journal: `${PLACEHOLDER_IMAGE_BASE}/journal-empty.png?v=1`,
    quests: `${PLACEHOLDER_IMAGE_BASE}/quests-empty.png?v=1`,
    templates: `${PLACEHOLDER_IMAGE_BASE}/templates-empty.png?v=1`,
    templatesSearch: `${PLACEHOLDER_IMAGE_BASE}/templates-search-empty.png?v=2`,
    conditionsSearch: `${PLACEHOLDER_IMAGE_BASE}/conditions-search-empty.png?v=1`,
    categorySearch: `${PLACEHOLDER_IMAGE_BASE}/category-search-empty.png?v=2`,
    premium: `${PLACEHOLDER_IMAGE_BASE}/premium.png?v=2`,
    onboarding: `${PLACEHOLDER_IMAGE_BASE}/onboarding.png?v=1`,
    xp: `${PLACEHOLDER_IMAGE_BASE}/xp-empty.png?v=1`,
} as const;
